import React from 'react'
import Notes from './Notes'

function GlobalNotes() {
  return (
    <Notes notetype="global"/>
  )
}

export default GlobalNotes
